/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

( function() {
    
    if( $('.page-header--about').length ){
            
        var triangle = gsap.timeline({repeat: -1});
           triangle.to(".js-about-triangle", {x: -40, y: -10, rotation:40, duration: 15, ease: 'none'});
           triangle.to(".js-about-triangle", {x: 60, y: -20, rotation:0, duration: 15, ease: 'none'});
           triangle.to(".js-about-triangle", {x: 40, y: 70, rotation:-20, duration: 10, ease: 'none'});
           triangle.to(".js-about-triangle", {x: 20, y: 50, rotation:10, duration: 20, ease: 'none'});
           triangle.to(".js-about-triangle", {x: 0, y: 0, rotation:0, duration: 12, ease: 'none'});

        triangle.pause();

        var square = gsap.timeline({repeat: -1});
            square.to(".js-about-square", {x: 100, y: 50, rotation:40, duration: 10, ease: 'none'});
            square.to(".js-about-square", {x: -60, y: 10, rotation:0, duration: 7, ease: 'none'});
            square.to(".js-about-square", {x: -20, y: -30, rotation:-20, duration: 25, ease: 'none'});
            square.to(".js-about-square", {x: 60, y: 100, rotation:10, duration: 12, ease: 'none'});
            square.to(".js-about-square", {x: 0, y: 0, rotation:0, duration: 8, ease: 'none'});

        square.pause();

        triangle.resume();
        square.resume();
        $('.js-about-white').addClass('active');            
        $('.js-about-red').addClass('active');            
    }
    
    var magnets = document.querySelectorAll('.js-benefit-circle');
    var strength = 100;

    magnets.forEach( (magnet) => {
        magnet.addEventListener('mousemove', moveMagnet );
        magnet.addEventListener('mouseout', function(event) {
            var _text = $(event.currentTarget).find('.js-benefit-front');
            TweenMax.to( event.currentTarget, 1, {x: 0, y: 0, ease: Power4.easeOut});
            TweenMax.to( _text, 1, {x: 0, y: 0, ease: Power4.easeOut});
        } );
    });

    function moveMagnet(event) {
        var magnetButton = event.currentTarget
        var bounding = magnetButton.getBoundingClientRect();
        var _text = $(event.currentTarget).find('.js-benefit-front');

        //console.log(magnetButton, bounding)
        TweenMax.to( magnetButton, 1, {
            x: ((( event.clientX - bounding.left)/magnetButton.offsetWidth) - 0.5) * strength,
            y: ((( event.clientY - bounding.top)/magnetButton.offsetHeight) - 0.5) * strength,
            ease: Power4.easeOut
        });
        TweenMax.to( _text, 1, {
            x: -(((( event.clientX - bounding.left)/magnetButton.offsetWidth) - 0.5) * strength),
            y: -(((( event.clientY - bounding.top)/magnetButton.offsetHeight) - 0.5) * strength),
            ease: Power4.easeOut
        });

      //magnetButton.style.transform = 'translate(' + (((( event.clientX - bounding.left)/(magnetButton.offsetWidth))) - 0.5) * strength + 'px,'+ (((( event.clientY - bounding.top)/(magnetButton.offsetHeight))) - 0.5) * strength + 'px)';
    }
    
} )();